import {
  useState,
  ReactElement,
  useContext,
  ReactNode,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";
import {
  HomeOutlined,
  EuroOutlined,
  UserOutlined,
  LogoutOutlined,
  HeartOutlined,
  ReconciliationOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  LeftOutlined,
  BookOutlined,
  BulbFilled,
  CalendarOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Image, Button, Row, Col } from "antd";
import { ItemType } from "antd/lib/menu/hooks/useItems";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

import "./App.css";

import { SignedInContext } from "./AppEnv";
import { SignedInDoctor, UnloggedDoctor } from "./auth/interfaces";

import {
  ADMIN_LOGIN_TOKEN,
  HOME_PATH,
  LOGIN_PATH,
  LOGIN_TOKEN,
  PATIENTS_PATH,
} from "./env";

const { Header, Content, Footer, Sider } = Layout;

export const MENU_KEYS = {
  HOME: "home",
  PATIENTS_REGISTRY: PATIENTS_PATH.substring(1),
  PATIENTS_POSTURAL_EXAMS: "patients-ep",
  DOC: "doc",
  CALE: "agenda",
  LPRICE: "price",
  TUTO: "tutorial",
  LOGOUT: "logout",
  STUDIO_ADMIN: "studio-admin",
  PATIENT_SHEET: "",
};

function getItem<ItemType>(
  label: string,
  key: string,
  icon: ReactElement = <></>,
  children: ItemType[] | undefined = undefined
) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const getMenuItems = (master: boolean) => {
  let items: ItemType[] = [
    getItem("Home", MENU_KEYS.HOME, <HomeOutlined rev={undefined} />),
    getItem(
      "Pazienti",
      MENU_KEYS.PATIENTS_REGISTRY,
      <UserOutlined rev={undefined} />
    ),
   /* getItem("Agenda", MENU_KEYS.CALE, <CalendarOutlined  rev={undefined} />), */
    getItem("Info personali", MENU_KEYS.DOC, <HeartOutlined rev={undefined} />),
    getItem("Tutorial", MENU_KEYS.TUTO, <BookOutlined rev={undefined} />),
  ];

  if (master)
    items.push(
      getItem(
        "Listino Prezzi",
        MENU_KEYS.LPRICE,
        <EuroOutlined rev={undefined} />
      ),
      getItem(
        "Studio",
        MENU_KEYS.STUDIO_ADMIN,
        <ReconciliationOutlined rev={undefined} />
      )
    );

  items.push(
    getItem("Esci", MENU_KEYS.LOGOUT, <LogoutOutlined rev={undefined} />)
  );
  return items;
};

const LoggedInWrapper = ({
  selectedHeader,
  selectedContent,
  hiddenSider,
  selectedMenuItem,
  adminPanel,
}: {
  selectedHeader: ReactNode;
  selectedContent: ReactNode;
  hiddenSider?: boolean;
  selectedMenuItem?: string;
  adminPanel?: boolean;
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [cookies, setCookie] = useCookies([LOGIN_TOKEN]);
  const setSignedInDoctor = useContext(SignedInContext).setSignedInDoctor;
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [siderHeight, setSiderHeight] = useState(0);
  const layoutRef = useRef<any>(null);

  const navigate = useNavigate();

  function updateSiderHeight() {
    setSiderHeight(layoutRef.current ? layoutRef.current.offsetHeight : 0);
  }

  useEffect(() => {
    setInterval(updateSiderHeight, 250);
  }); //TODO improve this with actual check

  useLayoutEffect(() => {
    if (layoutRef.current) window.addEventListener("resize", updateSiderHeight);
    updateSiderHeight();
    return () => window.removeEventListener("resize", updateSiderHeight);
  }, [collapsed]);

  const selectMenuItem = ({ key }: { key: string }) => {
    if (key === MENU_KEYS.LOGOUT) {
      //perform logout
      if (setSignedInDoctor) setSignedInDoctor(UnloggedDoctor);

      console.log(
        new Date(new Date().getTime() - 1000 * 60 * 60 * 2) +
          "tempo durtata token login"
      );

      //remove login token from cookies
      setCookie(LOGIN_TOKEN, undefined, {
        path: "/",
        expires: new Date(new Date().getTime() - 1000 * 60 * 60 * 2),
      });
      if (adminPanel)
        setCookie(ADMIN_LOGIN_TOKEN, undefined, {
          path: "/",
          expires: new Date(new Date().getTime() - 1000),
        });
      navigate("/app" + LOGIN_PATH);
    } else
      navigate(
        key != MENU_KEYS.HOME
          ? "/app" + HOME_PATH + "/" + key
          : "/app" + HOME_PATH
      );

    setCollapsed(true);
  };

  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 640 && (
        //Computer
        <Layout
          style={{
            minHeight: "100vh",
          }}
        >
          <Header>
            <div style={{ marginLeft: "1vh" }}>{selectedHeader}</div>
          </Header>
          <Layout
            ref={layoutRef}
            style={{
              minHeight: "80vh",
            }}
          >
            {!hiddenSider && (
              <Sider
                collapsedWidth={"7vh"}
                collapsed={collapsed}
                onCollapse={(value) => setCollapsed(value)}
                style={{
                  position: "absolute",
                  height: siderHeight + "px",
                  zIndex: 400,
                  opacity: 0.96,
                }}
              >
                <Menu
                  theme="dark"
                  selectedKeys={selectedMenuItem ? [selectedMenuItem] : []}
                  mode="inline"
                  items={getMenuItems(signedInDoctor.studioMaster)}
                  onClick={selectMenuItem}
                />
                <Button
                  className="sider-btn"
                  onClick={() => setCollapsed((oldCollapsed) => !oldCollapsed)}
                >
                  {(collapsed && <DoubleRightOutlined rev={undefined} />) ||
                    (!collapsed && <DoubleLeftOutlined rev={undefined} />)}
                </Button>
              </Sider>
            )}

            {hiddenSider && (
              <div
                style={{
                  maxWidth: "8vh",
                  background: "#9fddc5",
                  borderRadius: "0px 25px 25px 0px",
                  minWidth: "6vh",
                }}
              >
                <Button
                  style={{
                    minWidth: "6vh",
                  }}
                  onClick={() =>
                    adminPanel
                      ? selectMenuItem({ key: MENU_KEYS.LOGOUT })
                      : navigate(-1)
                  }
                >
                  <LeftOutlined rev={undefined} />
                </Button>
              </div>
            )}

            <Content style={{ zIndex: 0, marginLeft: "6vh" }}>
              <div
                className="shared-bg"
                style={{
                  position: "absolute",
                  zIndex: collapsed ? 0 : 2,
                  background: "none",
                  opacity: collapsed ? "0.0" : "0.32",
                  minWidth: "-webkit-fill-available",
                  minHeight: siderHeight + "px",
                }}
              />
              {selectedContent}
            </Content>
          </Layout>
          <Footer
            className="App-footer"
            style={{
              color: "rgba(39, 171, 154, 0.592)",
              textAlign: "center",
              minHeight: "2vh",
            }}
          >
            Produce By Physiomood Srl ©2022
          </Footer>
        </Layout>
      )}
      {width <= 640 && (
        //SmartPhone
        <Layout
          style={{
            minHeight: "100vh",
            maxWidth: "100%",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            zIndex: "1",
          }}
        >
          <Header>
            <div style={{ marginLeft: "1vh" }}>{selectedHeader}</div>
          </Header>
          <Layout
            ref={layoutRef}
            style={{
              overflowY: "auto", // Permette lo scroll verticale solo se necessario
              overflowX: "hidden", // Blocca lo scroll orizzontale
              backgroundColor: "#f0f2f5",
              position  : "relative",
              maxWidth: "100%", // Previene l'overflow orizzontale
              boxSizing: "border-box", // Evita problemi di larghezza con padding/border
            }}
            
          >
            {!hiddenSider && (
              <Sider
                collapsedWidth={"8vh"}
                collapsed={collapsed}
                onCollapse={(value) => setCollapsed(value)}
                style={{
                  position: "fixed",
                  height: siderHeight + "px",
                  zIndex: 400,
                  opacity: 0.96,
                }}
              >
                <Menu
                  theme="dark"
                  selectedKeys={selectedMenuItem ? [selectedMenuItem] : []}
                  mode="inline"
                  items={getMenuItems(signedInDoctor.studioMaster)}
                  onClick={selectMenuItem}
                />
                <Button
                  className="sider-btn"
                  onClick={() => setCollapsed((oldCollapsed) => !oldCollapsed)}
                >
                  {(collapsed && <DoubleRightOutlined rev={undefined} />) ||
                    (!collapsed && <DoubleLeftOutlined rev={undefined} />)}
                </Button>
              </Sider>
            )}
            {hiddenSider && width > 640 && (
              <div className="BackButton">
                <Button
                  style={{ minWidth: "6vh", 
                    }}
                  onClick={() =>
                    adminPanel
                      ? selectMenuItem({ key: MENU_KEYS.LOGOUT })
                      : navigate(-1)
                  }
                >
                  <LeftOutlined rev={undefined} /> 
                </Button>
              </div>
            )}
            {hiddenSider && width <= 640 && (
              <div className="BackButton">
                <Button
                  style={{
                    minWidth: "6vh",
                    minHeight: "6vh",
                    color: "white",
                    fontSize: "20px",
                  }}
                  onClick={() =>
                    adminPanel
                      ? selectMenuItem({ key: MENU_KEYS.LOGOUT })
                      : navigate(-1)
                  }
                >
                  {"<"}
                </Button>
              </div>
            )}

            <Content style={{ zIndex: 0, marginLeft: "6vh" }}>
              <div
                className="shared-bg"
                style={{
                  position: "absolute",
                  zIndex: collapsed ? 0 : 2,
                  background: "rgba(27, 54, 109, 0.64)",
                  opacity: collapsed ? "0.0" : "0.32",
                  minWidth: "-webkit-fill-available",
                  minHeight: siderHeight + "px",
                }}
              />
              {selectedContent}
            </Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default LoggedInWrapper;
